import { EmailTemplateProps } from "src/components/email/EmailTemplate";

export function PlainTextEmailTemplate(props: EmailTemplateProps) {
  return (
    <table
      cellPadding="0"
      cellSpacing="0"
      width="100%"
      style={{ width: "100%" }}
    >
      <tbody>
        <tr>
          <td style={{ background: "#fff" }}>
            <table cellPadding="0" cellSpacing="0" style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td
                    style={{ padding: "30px 0 30px 0" }}
                    dangerouslySetInnerHTML={{ __html: props.content }}
                  />
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export const plainTextEmailHead = `
<!doctype html>
<html>

<head>
  <meta charset="utf-8" />
  <meta name="color-scheme" content="light" />
</head>

<body>
  <link rel="stylesheet" href="https://use.typekit.net/dlm1ocu.css" />

  <style>
    html,
    body {
      background: #fff;
      font-family: "Soleil", sans-serif;
      font-size: 15px;
      line-height: 1.5;
      color: #000;
      margin: 0;
      padding: 0;
    }

    h1,
    h2,
    h3,
    h4,
    p {
      margin-top: 0;
      color: #000;
    }

    table {
      width: 100%;
      line-height: inherit;
      text-align: left;
      border-collapse: collapse;
    }

    table td {
      padding: 0 1rem;
    }

    a {
      color: #2970ff;
      text-decoration: none;
    }
  </style>
`;
